import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { NgSelectModule } from '@ng-select/ng-select';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { CpfCnpjMaskModule } from './pipes/cpf-cnpj-mask.module';
import { OwlDateTimeIntl, OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time.module';
import { NgxCurrencyModule } from 'ngx-currency';
import { NgxMaskModule } from 'ngx-mask';
import { CardHeaderComponent } from './components/card-header/card-header.component';
import { BackToTopComponent } from './components/back-to-top/back-to-top.component';
import { EmojiPickerComponent } from './components/emoji-picker/emoji-picker.component';
import { FormControlComponent } from './components/form-control/form-control.component';
import { FormControlErrorsComponent } from './components/form-control/form-control-errors/form-control-errors.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { PT_MOMENT_FORMATS } from './i18n/datepicker-formats';
import { DefaultDatePickerIntl } from './i18n/default-datepicker-i18n';
import { PreferenciasWebService } from './services/preferencias-web.service';
import { SelectEquipamentosClienteComponent } from './components/select-equipamentos-cliente/select-equipamentos-cliente.component';
import { ClientesSelectComponent } from './components/clientes-select/clientes-select.component';
import { InfoCobrancaChamadoComponent } from './components/info-cobranca-chamado/info-cobranca-chamado.component';
import { MatDialogModule } from '@angular/material';

@NgModule({
  declarations: [
    CardHeaderComponent,
    BackToTopComponent,
    EmojiPickerComponent,
    FormControlComponent,
    FormControlErrorsComponent,
    ToggleSwitchComponent,
    SelectEquipamentosClienteComponent,
    ClientesSelectComponent,
    InfoCobrancaChamadoComponent
  ],
  entryComponents: [
    InfoCobrancaChamadoComponent
  ],
  imports: [
    CommonModule,
    MDBBootstrapModule,
    PickerModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskModule,
    NgxCurrencyModule,
    NgSelectModule,
    CpfCnpjMaskModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    MatDialogModule
  ],
  exports: [
    CardHeaderComponent,
    BackToTopComponent,
    EmojiPickerComponent,
    FormControlComponent,
    ToggleSwitchComponent,
    SelectEquipamentosClienteComponent,
    ClientesSelectComponent
  ],
  providers: [
    PreferenciasWebService,
    { provide: OwlDateTimeIntl, useClass: DefaultDatePickerIntl },
    { provide: OWL_DATE_TIME_FORMATS, useValue: PT_MOMENT_FORMATS }
  ]
})
export class SharedModule { }
